import { useEffect } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { useUser } from "context/UserContext";
import { ESCURO } from "assets/coresTema";
import { get } from "utils/WebService";
import BaseDeDadosCreateEdit from "./BaseDeDadosCreateEdit";

/**
 * Ficha do devedor sozinha numa aba do navegador (/system?view=ficha&devedor=<id criptografado>&ficha=<nº da ficha>),
 * só para consulta. Aberta pela lista de casos da Análise de Atendimento; o login vem da aba que abriu
 * (temp_share_user, como a Monitoria). Fechar = fechar a aba.
 */
export default function FichaAvulsa() {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const { userPerfils, setUserPerfils } = useUser();
    const parametros = new URLSearchParams(window.location.search);
    const devedor = parametros.get("devedor");
    const ficha = parametros.get("ficha");

    useEffect(() => {
        document.title = ficha ? `Ficha ${ficha} - RAL` : "Ficha - RAL";
    }, [ficha]);

    // Perfis do usuário (a aba não passa pelo SystemWrapper, que é quem carrega)
    useEffect(() => {
        if (userPerfils && userPerfils.length) return;
        get("/users/by-token")
            .then(usuario => (usuario?.id ? get(`/users/by-id/${usuario.id}`) : null))
            .then(completo => { if (completo?.perfils) setUserPerfils(completo.perfils); })
            .catch(err => console.error("Erro ao carregar o perfil na ficha avulsa", err));
    }, [userPerfils, setUserPerfils]);

    return (
        <MDBox p={2} sx={{ minHeight: "100vh", background: darkMode ? ESCURO.fundo : "#f0f2f5" }}>
            {devedor ? (
                <BaseDeDadosCreateEdit
                    recordId={devedor}
                    idDevedorCarteira={ficha}
                    closeCreateEdit={() => window.close()}
                    isJuridico={false}
                    isViewOnly
                />
            ) : (
                <MDTypography variant="button" color="text">Ficha não informada.</MDTypography>
            )}
        </MDBox>
    );
}
